var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('combo-table',{attrs:{"query":_vm.queryAPI,"columns":_vm.columns,"queryParams":_vm.queryParams}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d211532","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":true}!./src/pages/cleaner/test-normal-table.vue
// module id = D/WM
// module chunks = 0